// Close-policy for the shared Dialog. Explicit closes (header X, Cancel, a footer
// action) are always honored; incidental closes (clicking the dimmed backdrop, or
// pressing Escape) are honored only when the dialog is `dismissable`. Destructive
// confirms (e.g. password-verified department delete) pass dismissable={false} so a
// stray click or Escape can't dismiss the modal and wipe in-progress input.

export type DialogCloseReason = 'backdrop' | 'escape' | 'explicit';

export function shouldClose(reason: DialogCloseReason, dismissable: boolean): boolean {
  if (reason === 'explicit') return true;
  return dismissable;
}
